var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "79px",
    viewBox: "0 0 84 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wise-Proctor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Wise-Proctor-Instructor-Main",
    transform: "translate(-1490.000000, -1613.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(611.000000, 1355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(879.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7448637,78.2718094 C81.8663132,78.903152 80.8635258,79.1558648 79.85982,78.903152 C71.7062506,77.0100259 62.6738841,74.8632628 49,78.2718094 C56.9033487,70.9503275 62.6734361,69.5615451 69.4479909,69.5615451 C74.215179,69.5615451 78.1040181,65.6485647 78.1040181,60.9781896 L78.1040181,12 L80.6127226,12 C82.4940605,12 84,13.5145189 84,15.4085015 L84,75.6213789 C84,76.630472 83.6228543,77.6404218 82.7451774,78.2718094 L82.7448637,78.2718094 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4386363,63.800396 C61.4252388,63.800396 53.2848751,65.4365628 44,75 L44,15.6043472 C44,14.9749762 44.1268729,14.3456052 44.5083866,13.8426566 C52.1404318,1.88824785 61.4250798,0 69.5654434,0 C70.4562272,0 71.3461025,0.377447329 71.982341,1.00681834 C72.6184886,1.63618934 73,2.51660765 73,3.39796975 L73,60.4026959 C72.872239,62.2907864 71.3462161,63.8005533 69.4385909,63.8005533 L69.4386363,63.800396 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3595667,63.8005533 C13.4936197,63.8005533 12,62.290764 12,60.4026959 L12.0008678,3.39796975 C12.0008678,2.51667507 12.3740617,1.63627923 12.9963403,1.00681834 C13.6186189,0.377447329 14.4891157,0 15.3605457,0 C23.1992385,0 31.0372647,1.88721417 38.502697,13.8426566 C38.7517818,14.3456276 39,14.9749986 39,15.6043472 L39,75 C29.9166611,65.4365179 23.1984164,63.800396 15.3601679,63.800396 L15.3595667,63.8005533 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,78.2704447 C20.2983729,74.982476 12.4330326,77.1324268 4.1866473,78.9029705 C3.17162218,79.156157 2.03007289,78.9029705 1.26900228,78.2704447 C0.507954318,77.6379189 0,76.6260764 0,75.6141436 L0,15.4148894 C0,13.5182154 1.52209592,12 3.42555403,12 L5.96260711,12 L5.96260711,60.9435113 C5.96260711,65.7495599 9.89516398,69.542953 14.7164483,69.542953 C21.4402393,69.6699867 26.0073427,70.9350382 34,78.2704447 L34,78.2704447 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.21c14934289d414edd61af9086a94c27.svg";
export { ForwardRef as ReactComponent };